export const isEmpty = (arr) => {
	let emptyArray = false;
	if(arr && typeof (arr) == "object"){
		emptyArray = arr.length <= 0;
	}
	else if(!arr && typeof (arr) == "object"){
		emptyArray = true;
	}
	return arr == null || emptyArray;
};

export const isNotEmpty = (s) => !isEmpty(s);

export const emptyListIfNull = (s) => {
	if(isEmpty(s) || s == null){
		return [];
	}
	return s;
};

export const sizeOf = (s) => {
	if(isEmpty(s) || s == null){
		return 0;
	}
	return s.length;
};
